import { render, staticRenderFns } from "./Inclusiones.vue?vue&type=template&id=0c12e8cc"
import script from "./Inclusiones.vue?vue&type=script&lang=js"
export * from "./Inclusiones.vue?vue&type=script&lang=js"
import style0 from "./Inclusiones.vue?vue&type=style&index=0&id=0c12e8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports